import parseHTML from 'html-react-parser';
import { FC, useState, useRef, useCallback, MouseEvent } from 'react';

import { PageContentStyles } from './PageContentStyles';

import { ImageSlider } from '@/components/shared/ImageSlider';
import { Modal } from '@/components/shared/Modal';
import { useToggle } from '@/hooks/useToggle';
import { Colors, IPlantImage } from '@/types';
import { Image } from '../shared/Image';
import { Button } from '../shared/Button';
import { Icons, IconsTypes } from '../shared/Icons';

interface IPageContent {
  pageBody: string;
}

export const PageContent: FC<IPageContent> = ({ pageBody }) => {
  const [showImgModal, _, setShowImgModal] = useToggle(false);
  const [imgToPreview, setImgToPreview] = useState<IPlantImage[]>([]);
  const [preSelectedIndex, setPreSelectedIndex] = useState<number>(0);

  const selectImgForPreview = useCallback(
    (imgEl: MouseEvent<HTMLElement>) => {
      const target = imgEl.target as HTMLImageElement;

      const elName = target.nodeName;

      if (elName === 'IMG' && target.parentNode?.parentNode?.nodeName === 'TD') {
        const imagesForSlider: IPlantImage[] = [];
        // selecting table row where all images relay
        const nodeImages = target.parentNode?.parentNode.parentNode?.querySelectorAll('img') ?? [];

        nodeImages.forEach((node) =>
          imagesForSlider.push({
            img: node.src,
            id: Math.random(),
            is_main: false,
            image: {
              small: node.src,
              medium: node.src,
              large: node.src,
            },
          }),
        );

        setImgToPreview(imagesForSlider);

        const indexOfClickedImg = imagesForSlider.findIndex((el) => el.img === target.src);
        setPreSelectedIndex(indexOfClickedImg);
        setShowImgModal(true);
      }
    },
    [setShowImgModal],
  );

  const onClose = () => {
    setShowImgModal(false);
    setImgToPreview([]);
  };

  const prevImage = () => {
    setPreSelectedIndex(index => index - 1);
  }
  const nextImage = () => {
    setPreSelectedIndex(index => index + 1);
  }

  return (
    <>
      <PageContentStyles />
      <div onClick={selectImgForPreview}>
        {pageBody && parseHTML(pageBody)}
      </div>

      {showImgModal && imgToPreview.length && (
        <Modal className="w-full max-w-[90vw] max-h-[90vh] bg-transparent" onClose={onClose}>
        <div className='main-image w-auto h-auto max-w-[90vw] max-h-[90vh]'>
          <Image
            className={`max-w-[90vw] max-h-[90vh] object-contain rounded-lg`}
            optimized={imgToPreview[preSelectedIndex].image}
            src={imgToPreview[preSelectedIndex].img}
            title={undefined}
            alt={imgToPreview[preSelectedIndex].img.split('/').reverse().at(0)}
          />
          {preSelectedIndex !== 0 && (<div className="absolute top-1/2 -translate-y-1/2 px-2">
            <Button variant={Colors.rounded} onClick={prevImage}>
              {Icons({ name: IconsTypes.ARROW_LEFT })}
            </Button>
          </div>)}
          {preSelectedIndex !== imgToPreview.length -1 && (<div className="absolute right-0 top-1/2 -translate-y-1/2 px-2">
            <Button variant={Colors.rounded} onClick={nextImage}>
              {Icons({ name: IconsTypes.ARROW_RIGHT, iconProps: { className: 'text-black-600' } })}
            </Button>
          </div>)}
        </div>
      </Modal>
      )}
    </>
  );
};
